<template>
  <div class="user-set">
    <div class="wrapper bg-color-red">
      <div class="wrapList">
        <div class="item acea-row row-between-wrapper on">
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <div class="pictrue">
                <img :src="user.avatar" />
              </div>
            </div>
            <div class="text">
              <div class="name line1">{{ user.realName }}</div>
              <div class="phone">昵称：{{ user.nickname }}</div>
            </div>
            <!-- <div class="shezhi">
              <span
                class="iconfont icon-jiantou"
                @click="$router.push({ path: '/user/data' })"
              ></span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <router-link :to="item.url ? item.url : ''" :key="'router' + index">
          <div class="name">{{ item.name }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@api/user";

export default {
  name: "UserSet",
  data: function() {
    return {
      user: {},
      list: [
        {
          name: "个人信息",
          url: "/user/data"
        },
        {
          name: "收货地址",
          url: "/user/add_manage"
        },
        {
          name: "账号与安全",
          url: "/user/uas"
        },
        {
          name: "支付设置",
          url: "/user/paymentset"
        }
      ]
    };
  },
  mounted: function() {
    this.User();
  },
  methods: {
    User: function() {
      let that = this;
      getUserInfo(2).then(res => {
        that.user = res.data;
      });
    }
  }
};
</script>
